import { EmailLockOutlineIcon } from './EmailLockOutlineIcon';

/**
 * author: Michael Irigoyen
 * id F4DE5AAA-B343-46ED-B1D3-CBDA05A61E87
 * name email-lock-outline
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-lock-outline.svg
 * tags
 * - Lock 
 */
export const EmailSecureOutlineIcon = EmailLockOutlineIcon;
export default EmailSecureOutlineIcon